// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StandaloneBookRoom-module--wrap--I2XZI","info":"StandaloneBookRoom-module--info--UFi23","image":"StandaloneBookRoom-module--image--16GE9"};